export const adjustLicenseeInfoData = data => {
  const { subjectId: subject } = data;
  let newData = {
    licenseNumber: data.licenseNumber,
    tariffType: data.tariffTypeId && data.tariffTypeId.tariffType,
    tariffEndDate: data.tariffEndDate,
    companyId: data.companyId,
    nameLegal: data.nameLegal,
    name: data.name,
    lastname: data.lastname,
    patronymic: data.patronymic,
    birthDate: data.birthDate,
    birthPlace: data.birthPlace,
    createdAtDate: data.createdAt,
    addressLegal: data.addressLegal,
    inn: data.inn,
    kpp: data.kpp,
    ogrn: data.ogrn,
    addressFact: data.addressFact,
    taxSystem: data.nds,
    phone: data.phone,
    phoneCode: data.phoneCode,
    email: data.email,
    site: data.site,
    picture: data.picture,
    bankAccount: data.bankAccount,
    eio: data.eio,
    cashierAccount: data.cashierAccount
  };
  data.bankAccount.forEach((_, index) => {
    newData[`bankName${index}`] = data.bankAccount[index][`bankName`] || null;
    newData[`bik${index}`] = data.bankAccount[index][`bik`] || null;
    newData[`accountCorr${index}`] =
      data.bankAccount[index][`accountCorr`] || null;
    newData[`bankAccountNum${index}`] =
      data.bankAccount[index][`bankAccountNum`] || null;
  });
  if (subject) {
    newData.subject = subject.subject;
    newData.subjectKey = subject.subjectKey;
    newData.subjectAbbr = subject.subjectAbbr;
  }
  return newData;
};

export const dataUpdateCompany = data => {
  let newData = {
    user: {
      user_id: data.userId
    },
    company: {
      company_id: data.companyId,
      nds: data.taxSystem
    }
  };
  newData.company.bank_account = [];
  if (data.subjectId) {
    newData.company.subject_id = data.subjectId;
  }
  if (data.nameLegal) {
    newData.company.name_legal = data.nameLegal;
  }
  if (data.addressLegal) {
    newData.company.address_legal = data.addressLegal;
  }
  if (data.phone) {
    newData.company.phone = data.phone;
  }
  if (data.phoneCode) {
    newData.company.phone_code = data.phoneCode;
  }

  if (data.addressFact) {
    newData.company.address_fact = data.addressFact;
  }

  newData.company.email = data.email;
  newData.company.site = data.site;
  if (data.picture) {
    newData.company.picture = data.picture;
  }
  if (data.bankAccount && data.bankAccount.length > 0) {
    data.bankAccount.forEach((_, index) => {
      let obj = {};

      obj["bank_account_id"] = data["bankAccountId" + index] || null;
      if (data["bankAccountNum" + index]) {
        obj["bank_account_num"] = data["bankAccountNum" + index];
      }
      if (data["accountCorr" + index]) {
        obj["account_corr"] = data["accountCorr" + index];
      }
      if (data["bankName" + index]) {
        obj["bank_name"] = data["bankName" + index];
      }
      if (data["bik" + index]) {
        obj["bik"] = data["bik" + index];
      }
      if (data["bankAddress" + index]) {
        obj["bank_address"] = data["bankAddress" + index];
      }
      newData.company.bank_account.push(obj);
    });
  }
  return newData;
};
